import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { checkoutService } from 'services';
import { Cart, SaveAddressParams } from 'types';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';

export const useSaveOrderAddress = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    ({
      shipAddressId,
      billAddressId,
      email,
      setOrderStep,
      setShowSubscriptionModal,
    }: SaveAddressParams) => {
      return checkoutService.saveOrderAddress(
        shipAddressId,
        email,
        billAddressId
      );
    },
    {
      onSuccess: (data, variables, context) => {
        displayNotification(i18n['Address saved Successfully']);
        queryClient.invalidateQueries([ServerStateKeysEnum.userCurrentCart]); // this is to handle treys creating new line items after selecting address
        const currentCart = queryClient.getQueryData<Cart>(
          ServerStateKeysEnum.userCurrentCart
        );
        const hasActiveSubscription = data.subscriptions?.some(
          subscription => subscription.is_subscription_active === true
        );
        variables.setShowSubscriptionModal(hasActiveSubscription);
        if (currentCart?.checkoutStates.includes('delivery')) {
          variables.setOrderStep('delivery');
        } else if (currentCart?.checkoutStates.includes('payment')) {
          variables.setOrderStep('payment');
        } else {
          variables.setOrderStep('confirm');
        }
        if (currentCart) {
          currentCart.shipToAddressId = variables.shipAddressId;
          currentCart.billToAddressId = variables.billAddressId;
          currentCart.state = data.order.data.attributes.state;
          currentCart.shipTotal = data.order.data.attributes.ship_total;
          currentCart.displayShipTotal =
            data.order.data.attributes.display_ship_total;
          currentCart.taxTotal = data.order.data.attributes.tax_amount;
          currentCart.displayTaxTotal =
            data.order.data.attributes.display_tax_amount;
          currentCart.displayTotal = data.order.data.attributes.display_total;
          queryClient.setQueryData(
            ServerStateKeysEnum.userCurrentCart,
            currentCart
          );
        }
      },

      //   onError: e => {
      //     {
      //       !e.response.data &&
      //         displayNotification(
      //           i18n['Failed to save order address!'],
      //           'danger'
      //         );
      //     }
      //   },

      onError: e => {
        const error = e as { response?: { data?: any } };
        if (!error.response?.data) {
          displayNotification(i18n['Failed to save order address!'], 'danger');
        }
      },
    }
  );
};
